import React, { useState, useMemo, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'
import BackAnchor from '../../../../shared/components/BackAnchor'
import { clearLastDebtAction } from '../../../../redux/actions'
import ContactInformationForm from './forms/ContactInformationForm'

const ContactInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const isSummary = useMemo(() => {
    return JSON.parse(new URLSearchParams(history.location.search).get('isSummary') ?? false)
  }, [history])

  const [validateForm, setValidateForm] = useState()

  useEffect(() => {
    localStorage.removeItem('action')
  }, [])

  useEffect(() => {
    return () => {
      if (localStorage.getItem('action') !== 'next') {
        dispatch(clearLastDebtAction())
      }
    }
  }, [])

  const onNext = () => {
    try {
      localStorage.setItem('action', 'next')
      const newDebtInfo = validateForm()
      if (newDebtInfo) {
        if (isSummary) {
          history.push(`/${i18n.language}${t('routes.review_summary')}`)
        } else {
          history.push(`/${i18n.language}${t('routes.update_mailing_address_question')}`)
        }
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <div className="container">
      <BackAnchor />
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('contact_information.title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <ContactInformationForm setValidateForm={setValidateForm} setIsError={setIsError} />
        </div>
      </div>
      <div className="col-xs-12 col-md-8">
        <ContinueCancelButtons continueClick={onNext} showCancel={false} />
      </div>
    </div>
  )
}

export default withTranslation('common')(ContactInformationView)
